import { render, staticRenderFns } from "./posDetails.vue?vue&type=template&id=5ec5a203&"
import script from "./posDetails.vue?vue&type=script&lang=js&"
export * from "./posDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports